import "../news/stylenews.css";
import React from "react";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { getNews, getFileById } from "../../services/index";
import { baseURL, imgUrl } from "../../constants/index";
import moment from "moment";
import { Pagination } from "antd";
export class Sensor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curPage: 1,
      newList: [],
      total: 0,
      index: 0,
    };
  }
  componentDidMount() {
    if(localStorage.getItem("curPage")){
      this.getNewList({
        page: parseInt(localStorage.getItem("curPage")),
        pageSize: 2,
        news: {
          business_type: "区域遥感",
        },
      });
      this.setState({
        curPage:parseInt(localStorage.getItem("curPage")),
      })
    }else{
      this.getNewList({
        page: this.state.curPage,
        pageSize: 2,
        news: {
          business_type: "区域遥感",
        },
      });
    }
    
  }
  getNewList(params) {
    getNews(params).then(async(res) => {
      if (res.code == 200) {
        let list = res.data.data;
        let newObj1 = await getFileById({
          id: parseInt(list[0].cover_photo),
        }).then((res1) => {
          return {
            ...list[0],
            cover_photo: baseURL + imgUrl + res1.data[0].name,
          };
        });
        let newObj2 = null;
        if (list.length == 2) {
          newObj2 = await getFileById({
            id: parseInt(list[1].cover_photo),
          }).then((res1) => {
            return {
              ...list[1],
              cover_photo: baseURL + imgUrl + res1.data[0].name,
            };
          });
        }
        this.setState({
          newList: list.length==2?[newObj1,newObj2]:[newObj1],
          total: res.data.total,
        });
      }
    });
  }
  onChange(pageNumber) {
    this.getNewList({
      page: pageNumber,
      pageSize: 2,
      news: {
        business_type: "区域遥感",
      },
    });
  }
  savePage() {
    localStorage.setItem("curPage", this.state.curPage);
    localStorage.setItem("typeName", "区域遥感");
  }
  render() {
    return (
      <div className="sensor_div">
        <div className="news_list_div">
          <div className="sensor_category">
            <div className="sensor_category_items">
              <div className="category_item category_item_active">
                <span className="category_link">区域遥感</span>
              </div>
            </div>
          </div>
          <div
            id="news_list_content_id"
            className="news_list_content"
            data-animation="once"
            loaded="true"
            min-height="417"
            animated="true"
          >
            <div className="news_litem">
              <div className="news_litem_news">
                {this.state.newList.map((i) => {
                  return (
                    <div
                      className="p_articles"
                      data-dismoveable=""
                      data-foreachitem=""
                      key={i.id}
                    >
                      <div className="p_images higher">
                        <div
                          className="p_thumbnail"
                          onClick={() => {
                            this.savePage();
                          }}
                        >
                          <Link to={`/detail?fileid=${i.id}`}>
                            <img src={i.cover_photo} alt={i.name} />
                          </Link>
                        </div>
                      </div>
                      <div className="p_content">
                        <div className="p_header">
                          <div
                            className="p_TitleBox"
                            onClick={() => {
                              this.savePage();
                            }}
                          >
                            <Link to={`/detail?fileid=${i.id}`}> {i.name}</Link>
                          </div>
                          <div className="p_assist">
                            <div className="p_TimeBox ">
                              <div className="p_AssistNameA">
                                <div className="font">
                                  <span>发布时间：</span>
                                </div>
                              </div>
                              <div className="p_time">
                                <div className="font">
                                  {moment(i.journalism_time).format(
                                    "YYYY-MM-DD"
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="p_SummaryBox ">
                          <div className="p_nameB">
                            <div className="font">
                              <span className="i_summary">摘要：</span>
                            </div>
                          </div>
                          <article className="p_summary" title={i.abstracts}>
                            {i.abstracts}
                          </article>
                        </div>
                        <div className="p_KeywordBox">
                          <div className="p_AssistNameF">
                            <div className="font">
                              <span className="i_keywords">关键词：</span>
                              <span className="i_keywords">{i.antistop}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div
                  className="p_ListHline"
                  data-dismoveable=""
                  data-foreachitem=""
                ></div>
              </div>
            </div>
            <div className="page">
              <Pagination
                showQuickJumper
                current={this.state.curPage}
                total={this.state.total}
                showSizeChanger={false}
                onChange={(pageNumber) => {
                  this.setState({
                    curPage: pageNumber,
                  });
                  this.onChange(pageNumber);
                }}
                pageSize={2}
              />
            </div>
          </div>
        </div>
        <TopMenu />
      </div>
    );
  }
}
